module.exports = "<meta property=\"og:description\" content=\"{{ description }}\"/>"